<template>
    <div class="status-container" v-if="item"><v-progress-linear class="barra" :color="corStatus"
            :model-value="valorProgresso" />
        <select class="select-status" :title="tituloSelectStatus" :disabled="!usuarioPodeEditar"
            :style="{ color: item?.status === 'Concluído' ? 'var(--cor-bg)' : 'black' }" v-model="item.status"
            @change="editarStatus">
            <option value="" hidden>Status</option>
            <option value="Pendente" style="color: rgb(255, 145, 0);">A iniciar</option>
            <option hidden value="Em andamento 0%" style="color: rgb(0, 47, 255);">Em andamento</option>
            <option value="Em andamento" style="color: rgb(0, 47, 255);">Em andamento</option>
            <option value="Em andamento 25%" style="color: rgb(0, 47, 255);">Em andamento 25%</option>
            <option value="Em andamento 50%" style="color: rgb(0, 47, 255);">Em andamento 50%</option>
            <option value="Em andamento 75%" style="color: rgb(0, 47, 255);">Em andamento 75%</option>
            <option value="Concluído" style="color: rgb(0, 192, 0);">Concluído</option>
            <option value="Cancelada" style="color: var(--cor-erro);">Cancelada</option>
        </select>
    </div>
</template>
<script>
import {
    tarefaTemResponsavel,
    MENSAGEM_TAREFA_SEM_RESPONSAVEL,
} from '@/utils/tarefaStatus'

export default {
    name: 'BarraProgresso',
    props: {
        propItem: {
            required: true,
        },
        idUsuario: {
            required: true,
        },
        isCoordenador: {
            default: false,
        },
        isAuditor: {
            default: false,
        },
        exigirResponsavel: {
            type: Boolean,
            default: false,
        },
    },
        data() {
            return {
                item: null,
                statusAntesEdicao: null,
                statusPropVisto: null,
                fonteProp: null,
            }
        },
        created() {
            this.aplicarProp(this.propItem)
        },
        watch: {
            propItem: {
                handler(val) {
                    this.aplicarProp(val)
                },
                deep: true,
            },
        },
    computed: {
        corStatus() {
            const status = this.item?.status;
            if (status === 'Cancelada') return 'var(--cor-erro)';
            if (status === 'Concluído') return 'var(--cor-sucesso)';
            if (status === 'Pendente') return 'var(--cor-alerta)';
            if (status?.includes('Em andamento')) return 'var(--cor-ok)';
            return 'red';
        },
        valorProgresso() {
            const status = this.item?.status;
            if (['Concluído', 'Cancelada', 'Pendente'].includes(status)) return 100;
            if (status?.startsWith('Em andamento')) {
                const porcentagem = status.split(' ')[2]?.replace('%', '');
                return Number(porcentagem) || 0;
            }
            return 2;
        },
        usuarioPodeEditar() {
            const tarefa = this.propItem ?? this.item
            if (this.exigirResponsavel && !tarefaTemResponsavel(tarefa)) {
                return false
            }
            return (
                parseInt(tarefa?.responsavel_id) === parseInt(this.idUsuario) ||
                this.isCoordenador ||
                this.isAuditor
            )
        },
        tituloSelectStatus() {
            const tarefa = this.propItem ?? this.item
            if (this.exigirResponsavel && !tarefaTemResponsavel(tarefa)) {
                return MENSAGEM_TAREFA_SEM_RESPONSAVEL
            }
            return this.item?.status || ''
        },
    },
        methods: {
            aplicarProp(val) {
                if (!val) {
                    this.item = null
                    this.statusAntesEdicao = null
                    this.statusPropVisto = null
                    this.fonteProp = null
                    return
                }
                const statusProp = val.status ?? null
                const fonteNova = val !== this.fonteProp
                this.fonteProp = val
                if (fonteNova || !this.item || this.item.id !== val.id) {
                    this.item = { ...val }
                    this.statusAntesEdicao = statusProp
                    this.statusPropVisto = statusProp
                    return
                }
                this.item.responsavel_id = val.responsavel_id
                if (statusProp !== this.statusPropVisto) {
                    this.item.status = statusProp
                    this.statusAntesEdicao = statusProp
                    this.statusPropVisto = statusProp
                }
            },
            editarStatus() {
            const tarefa = this.propItem ?? this.item
            if (this.exigirResponsavel && !tarefaTemResponsavel(tarefa)) {
                this.item.status = this.statusAntesEdicao
                window.alert(MENSAGEM_TAREFA_SEM_RESPONSAVEL)
                return
            }
            this.$emit('editarStatus', this.item.id, {
                status: this.item.status,
                statusAnterior: this.statusAntesEdicao,
            })
            this.statusAntesEdicao = this.item.status
        },
    },
}
</script>
<style scoped>
.status-container {
    position: relative !important;
    min-width: 10rem !important;
}

.barra {
    border: 1px solid var(--cor-fonte-fraca) !important;
    border-radius: 25px !important;
    height: 2rem !important
}

.select-status {
    opacity: 1 !important;
    border: none !important;
    padding-left: 0.5rem !important;
    position: absolute !important;
    top: 0 !important;
    left: 0rem !important;
    outline: none !important;
    border-radius: 25px !important;
    height: 2rem !important;
    text-align: center !important;
    background-color: transparent !important;
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
}
</style>